var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shown)?_c('div',{staticClass:"item-shadow",style:(_vm.style)},[(_vm.config.texture_url)?_c('div',{staticClass:"item-shadow-texture"},[_c('div',{staticClass:"item-shadow-texture-img",style:({ backgroundImage: ("url(" + (_vm.config.texture_url) + ")") })})]):_c('div',{staticClass:"item-shadow-image"},[_c('img',{attrs:{"src":_vm.config.svg_url}})])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b06fbe3c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/js/components/ItemShadow.vue
// module id = 570
// module chunks = 0